import React from "react";
import { Col, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";
import { Link } from "react-router-dom";

import classNames from "classnames";

import { store } from "../..";
import { tournamentManagementActions } from "../../features/tourneymgmt/tournamentManagementSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import { getTeamsTournaments } from "../../lib/api";
import { TOURNAMENT_LOGO_URL } from "../../lib/globals";
import { defaultDateFormat } from "../../lib/utils";
import { ITournament } from "../../types/api";

export const loader = async ({ params }: any) => {
    const { teamId } = params;
    const promises: Array<any> = [getTeamsTournaments(teamId)];

    const masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    !masterTournaments.length &&
        promises.push(
            store.dispatch(tournamentManagementActions.getMasterTournaments()),
        );

    const [{ tournaments }] = await Promise.all(promises);

    return {
        teamId,
        tournaments,
    };
};

const TournamentRegistrations = (): React.JSX.Element => {
    const { teamId, tournaments } = useLoaderData() as {
        teamId: number;
        tournaments: ITournament[];
    };
    const masterTournaments = useAppSelector(
        state => state.tournamentmanagement.masterTournaments,
    );

    return (
        <Row className={classNames("tournamentRegistrationsGrid")}>
            {tournaments
                .sort((a, b) => {
                    const dateA = new Date(a.startDate || 0).getTime();
                    const dateB = new Date(b.startDate || 0).getTime();

                    return dateA - dateB;
                })
                .map(t => {
                    const masterTournament = masterTournaments.find(
                        mt => t.parent === mt.id,
                    );
                    return (
                        <Col className={classNames("tournamentRegistration")}>
                            <h4 className={classNames("text-center")}>
                                <Link
                                    to={`/tournaments/${t.id}`}
                                    target="_blank"
                                >
                                    {masterTournament?.name}
                                </Link>
                            </h4>
                            <div className={classNames("gridContainer")}>
                                <img
                                    className="tournamentLogo"
                                    src={`${TOURNAMENT_LOGO_URL}${masterTournament?.logo}`}
                                />
                                <div>
                                    <ul>
                                        <li className={classNames("h5")}>
                                            {defaultDateFormat.format(
                                                new Date(
                                                    t?.startDate as string,
                                                ),
                                            )}
                                            {" - "}
                                            {defaultDateFormat.format(
                                                new Date(t?.endDate as string),
                                            )}
                                        </li>
                                        <li className={classNames("h5")}>
                                            Age Level: {t.ageLevel}
                                        </li>
                                        <li className={classNames("h5")}>
                                            Competition Level: {t.designation}
                                        </li>
                                        <li className={classNames("h5")}>
                                            Eligible to play Friday?{" "}
                                            {t.schedulingData.noFriday.includes(
                                                teamId,
                                            )
                                                ? "No"
                                                : "Yes"}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </Col>
                    );
                })}
        </Row>
    );
};

export default TournamentRegistrations;
